import moment from 'moment'

export const getUniqueNodeId = (nodeData, nodes) => {
    // Get amount of same nodes
    let totalSameNodes = 0
    for (let i = 0; i < nodes.length; i += 1) {
        const node = nodes[i]
        if (node.data.name === nodeData.name) {
            totalSameNodes += 1
        }
    }
    
    // Get unique id
    let nodeId = `${nodeData.name}_${totalSameNodes}`
    // console.log("totalSameNodes---",nodeId)

    for (let i = 0; i < nodes.length; i += 1) {
        const node = nodes[i]
        if (node.id === nodeId) {
            totalSameNodes += 1
            nodeId = `${nodeData.name}_${totalSameNodes}`
        }
    }
    return nodeId
}

export const initializeDefaultNodeData = (nodeParams) => {
    const initialValues = {}

    for (let i = 0; i < nodeParams.length; i += 1) {
        const input = nodeParams[i]
        initialValues[input.name] = input.default || ''
    }

    return initialValues
}

export const initNode = (nodeData, newNodeId) => {

    const outputAnchors: any = []
    const outputParams: any = []
    const inputControls: any = []
    const outputControls: any = []
    const inputAnchors: any = nodeData?.inputAnchors || []
    const inputParams: any = []
    const incoming = nodeData.inputs ? nodeData.inputs.length : 0
    const controlInput = nodeData.controlInputs ? nodeData.controlInputs.length : 0
    const controlOutput = nodeData.controlOutputs ? nodeData.controlOutputs.length : 0
    const inputParam = nodeData?.inputParams ? nodeData?.inputParams?.length : 0
    const inputAnchor = nodeData?.inputAnchors ? nodeData?.inputAnchors?.length : 0
    const outputParam = nodeData?.outputParams ? nodeData?.outputParams?.length : 0
    const outgoing = 1


    const whitelistTypes = ['asyncOptions', 'options', 'string', 'number', 'boolean', 'password', 'json', 'code', 'date', 'file', 'folder']

    // Inputs
    for (let i = 0; i < incoming; i += 1) {
        const newInput = {
            ...nodeData.inputs[i],
            id: `${newNodeId}-input-${nodeData.inputs[i].name}-${nodeData.inputs[i].type}`
        }
        if (whitelistTypes.includes(nodeData.inputs[i].type)) {
            inputParams.push(newInput)
        } else {
            inputAnchors.push(newInput)
        }
    }

    

    // Credential
    if (nodeData.credential) {
        const newInput = {
            ...nodeData.credential,
            id: `${newNodeId}-input-${nodeData.credential.name}-${nodeData.credential.type}`
        }
        inputParams.unshift(newInput)
    }

    for (let i = 0; i < outgoing; i += 1) {
        if (nodeData.outputs && nodeData.outputs.length) {
            
            for (let j = 0; j < nodeData.outputs.length; j += 1) {
                
                const newOutputOption = {
                    ...nodeData.outputs[j],
                    id: `${newNodeId}-output-${nodeData.outputs[j].name}-${nodeData.outputs[j].type}`,
                    name: nodeData.outputs[j].name,
                    label: nodeData.outputs[j].label,
                    type: nodeData.outputs[j].type,
                }
                outputAnchors.push(newOutputOption)
            }
            
        } 
    }

    // InputControls
    for (let i = 0; i < controlInput; i += 1) {
    const currentInput = nodeData.controlInputs[i];

    const newInput = {
        ...currentInput,
        id: currentInput.id || `${newNodeId}-input-control-${currentInput.name}-${currentInput.name}`
    };

    inputControls.push(newInput);
    }

    // OnputControls
    for (let i = 0; i < controlOutput; i += 1) {
        const currentOutput = nodeData.controlOutputs[i];

        const newoutput = {
            ...currentOutput,
            id: currentOutput.id || `${newNodeId}-output-control-${nodeData.controlOutputs[i].name}-${nodeData.controlOutputs[i].name}`
        };
    
        outputControls.push(newoutput)
    }


    // inputParams
    for (let i = 0; i < inputParam; i += 1) {
        const newoutput = {
            ...nodeData.inputParams[i],
            id: `${newNodeId}-output-control-${nodeData.inputParams[i].name}-${nodeData.inputParams[i].name}`
        }

        if (whitelistTypes.includes(nodeData.inputParams[i].type)) {
            inputParams.push(newoutput)
        } else {
            inputAnchors.push(newoutput)
        }
        // inputParams.push(newoutput)
    }


    // for (let i = 0; i < inputAnchor; i += 1) {
    //     const newoutput = {
    //         ...nodeData.inputAnchors[i],
    //         id: `${newNodeId}-output-control-${nodeData.inputAnchors[i].name}-${nodeData.inputAnchors[i].name}`
    //     }

    //     if (whitelistTypes.includes(nodeData.inputAnchors[i].type)) {
    //         inputParams.push(newoutput)
    //     } else {
    //         inputAnchors.push(newoutput)
    //     }
        
    // }


    //output Params

    // for (let i = 0; i < nodeData.outputAnchors.length; i += 1) {
    //     const param = nodeData.outputAnchors[i];
    
    //     if (param.visibilityType !== 'Parameter') { 
    //         const newoutput = {
    //             ...param,
    //             id: `${newNodeId}-output-control-${param.name}-${param.name}`
    //         };
    //         outputAnchors.push(newoutput);
    //     }
    // }
    


    // Inputs
    if (nodeData.inputs) {
        nodeData.inputAnchors = inputAnchors
        nodeData.inputParams = inputParams
        nodeData.inputs = initializeDefaultNodeData(nodeData.inputs)
    } else {
        nodeData.inputAnchors = inputAnchors
        nodeData.inputParams = inputParams
        nodeData.inputs = {}
    }

    nodeData.controlInputs = inputControls

    // Outputs
    if(outputAnchors.length > 0){
        if (nodeData.outputs) {
            nodeData.outputs = initializeDefaultNodeData(outputAnchors)
            nodeData.outputAnchors = outputAnchors
            nodeData.controlOutputs = outputControls
        } else {
            nodeData.outputs = {}
        }
    }
   
    // Credential
    if (nodeData.credential) nodeData.credential = ''


    nodeData.id = newNodeId
   
    return nodeData
}

export const getEdgeLabelName = (source) => {
    const sourceSplit = source.split('-')
    if (sourceSplit.length && sourceSplit[0].includes('ifElse')) {
        const outputAnchorsIndex = sourceSplit[sourceSplit.length - 1]
        return outputAnchorsIndex === '0' ? 'true' : 'false'
    }
    return ''
}

export const isValidConnection = (connection, reactFlowInstance) => {
    const sourceHandle = connection.sourceHandle
    const targetHandle = connection.targetHandle
    const target = connection.target

    //sourceHandle: "llmChain_0-output-llmChain-BaseChain"
    //targetHandle: "mrlkAgentLLM_0-input-model-BaseLanguageModel"

    let sourceTypes = sourceHandle.split('-')[sourceHandle.split('-').length - 1].split('|')
    sourceTypes = sourceTypes.map((s) => s.trim())
    let targetTypes = targetHandle.split('-')[targetHandle.split('-').length - 1].split('|')
    targetTypes = targetTypes.map((t) => t.trim())

    if (targetTypes.some((t) => sourceTypes.includes(t))) {
        let targetNode = reactFlowInstance.getNode(target)
        if (!targetNode) {
            if (!reactFlowInstance.getEdges().find((e) => e.targetHandle === targetHandle)) {
                return true
            }
        } else {
            const targetNodeInputAnchor =
                targetNode.data.inputAnchors.find((ancr) => ancr.id === targetHandle) ||
                targetNode.data.inputParams.find((ancr) => ancr.id === targetHandle) ||
                targetNode.data.inputControls.find((ancr) => ancr.id === targetHandle) ||
                targetNode.data.outputControls.find((ancr) => ancr.id === targetHandle)

            if (
                (targetNodeInputAnchor &&
                    !targetNodeInputAnchor?.list &&
                    !reactFlowInstance.getEdges().find((e) => e.targetHandle === targetHandle)) ||
                targetNodeInputAnchor?.list
            ) {
                return true
            }
        }
    }
    return false
}

export const convertDateStringToDateObject = (dateString) => {
    if (dateString === undefined || !dateString) return undefined

    const date = moment(dateString)
    if (!date.isValid) return undefined

    // Sat Sep 24 2022 07:30:14
    return new Date(date.year(), date.month(), date.date(), date.hours(), date.minutes())
}

export const getFileName = (fileBase64) => {
    let fileNames: any = []
    if (fileBase64.startsWith('[') && fileBase64.endsWith(']')) {
        const files = JSON.parse(fileBase64)
        for (const file of files) {
            const splitDataURI = file.split(',')
            const filename = splitDataURI[splitDataURI.length - 1].split(':')[1]
            fileNames.push(filename)
        }
        return fileNames.join(', ')
    } else {
        const splitDataURI = fileBase64.split(',')
        const filename = splitDataURI[splitDataURI.length - 1].split(':')[1]
        return filename
    }
}

export const getFolderName = (base64ArrayStr) => {
    try {
        const base64Array = JSON.parse(base64ArrayStr)
        const filenames: any = []
        for (let i = 0; i < base64Array.length; i += 1) {
            const fileBase64 = base64Array[i]
            const splitDataURI = fileBase64.split(',')
            const filename = splitDataURI[splitDataURI.length - 1].split(':')[1]
            filenames.push(filename)
        }
        return filenames.length ? filenames.join(',') : ''
    } catch (e) {
        return ''
    }
}

export const generateExportFlowData = (flowData) => {
    const nodes = flowData.nodes
    const edges = flowData.edges

    for (let i = 0; i < nodes.length; i += 1) {
        nodes[i].selected = false
        const node = nodes[i]

        const newNodeData = {
            id: node.data.id,
            label: node.data.label,
            version: node.data.version,
            name: node.data.name,
            type: node.data.type,
            baseClasses: node.data.baseClasses,
            category: node.data.category,
            description: node.data.description,
            inputParams: node.data.inputParams,
            inputAnchors: node.data.inputAnchors,
            inputs: {},
            outputAnchors: node.data.outputAnchors,
            outputs: node.data.outputs,
            selected: false
        }

        // Remove password, file & folder
        if (node.data.inputs && Object.keys(node.data.inputs).length) {
            const nodeDataInputs = {}
            for (const input in node.data.inputs) {
                const inputParam = node.data.inputParams.find((inp) => inp.name === input)
                if (inputParam && inputParam.type === 'password') continue
                if (inputParam && inputParam.type === 'file') continue
                if (inputParam && inputParam.type === 'folder') continue
                nodeDataInputs[input] = node.data.inputs[input]
            }
            newNodeData.inputs = nodeDataInputs
        }

        nodes[i].data = newNodeData
    }
    const exportJson = {
        nodes,
        edges
    }
    return exportJson
}

export const getAvailableNodesForVariable = (nodes, edges, target, targetHandle) => {
    // example edge id = "llmChain_0-llmChain_0-output-outputPrediction-string|json-llmChain_1-llmChain_1-input-promptValues-string"
    //                    {source}  -{sourceHandle}                           -{target}  -{targetHandle}
    const parentNodes: any = []
    const inputEdges = edges.filter((edg) => edg.target === target && edg.targetHandle === targetHandle)
    if (inputEdges && inputEdges.length) {
        for (let j = 0; j < inputEdges.length; j += 1) {
            const node = nodes.find((nd) => nd.id === inputEdges[j].source)
            parentNodes.push(node)
        }
    }
    return parentNodes
}

export const rearrangeToolsOrdering = (newValues, sourceNodeId) => {
    // RequestsGet and RequestsPost have to be in order before other tools
    newValues.push(`{{${sourceNodeId}.data.instance}}`)

    const sortKey = (item) => {
        if (item.includes('requestsGet') || item.includes('readFile')) {
            return 0
        } else if (item.includes('requestsPost') || item.includes('writeFile')) {
            return 1
        } else {
            return 2
        }
    }

    newValues.sort((a, b) => sortKey(a) - sortKey(b))
}

export const throttle = (func, limit) => {
    let lastFunc
    let lastRan

    return (...args) => {
        if (!lastRan) {
            func(...args)
            lastRan = Date.now()
        } else {
            clearTimeout(lastFunc)
            lastFunc = setTimeout(() => {
                if (Date.now() - lastRan >= limit) {
                    func(...args)
                    lastRan = Date.now()
                }
            }, limit - (Date.now() - lastRan))
        }
    }
}

export const generateRandomGradient = () => {
    function randomColor() {
        var color = 'rgb('
        for (var i = 0; i < 3; i++) {
            var random = Math.floor(Math.random() * 256)
            color += random
            if (i < 2) {
                color += ','
            }
        }
        color += ')'
        return color
    }

    var gradient = 'linear-gradient(' + randomColor() + ', ' + randomColor() + ')'

    return gradient
}

export const getInputVariables = (paramValue) => {
    const returnVal = paramValue
    const variableStack: any = []
    const inputVariables: any = []
    let startIdx = 0
    const endIdx = returnVal.length

    while (startIdx < endIdx) {
        const substr = returnVal.substring(startIdx, startIdx + 1)

        // Store the opening double curly bracket
        if (substr === '{') {
            variableStack.push({ substr, startIdx: startIdx + 1 })
        }

        // Found the complete variable
        if (substr === '}' && variableStack.length > 0 && variableStack[variableStack.length - 1].substr === '{') {
            const variableStartIdx = variableStack[variableStack.length - 1].startIdx
            const variableEndIdx = startIdx
            const variableFullPath = returnVal.substring(variableStartIdx, variableEndIdx)
            inputVariables.push(variableFullPath)
            variableStack.pop()
        }
        startIdx += 1
    }
    return inputVariables
}

export const isValidURL = (url) => {
    try {
        return new URL(url)
    } catch (err) {
        return undefined
    }
}
